import styled from 'styled-components';

const Select = styled.select`
  min-width: 130px;
  height: 40px;
  padding: ${props => !!props.padding ? `0 ${props.padding}px` : '0 15px'};
  appearance: listbox;
  font-size: 14px;
  border: 1px solid #d1d1d1;
  border-radius: 0;
  background-color: #fff;
  background-size: 10px;
  outline: none;

  &::-ms-expand { // IE10 까지만 화살표 제거됨...
    display: none;
  }

  &:disabled {
    color: #585858;
    background-color: #f1f1f1;
  }
`

export default Select;



// WEBPACK FOOTER //
// ./client/components/Styled/Select/index.js